export default __webpack_public_path__ + "static/media/arrow-down.a4d42b8e.svg";